var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgRocketBig = function SvgRocketBig(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.67 22.718C41.257 12.705 54.824 6.251 66.72 6.472c.677.019 1.223.585 1.24 1.286.278 12.332-5.991 26.41-15.647 35.342-.155 8.518-3.52 16.812-9.321 22.835-.254.26-.622.424-.983.424-.124 0-.246-.018-.363-.058-.455-.158-.83-.522-.899-1.017l-1.401-10.158-1.354 1.255a1.238 1.238 0 01-1.744-.05L19.929 39.39a1.353 1.353 0 01-.05-1.81l1.208-1.405-9.785-1.455a1.285 1.285 0 01-1.026-.894 1.356 1.356 0 01.315-1.35c5.883-6.106 13.873-9.598 22.08-9.759zm17.86 8.432a6.211 6.211 0 004.49-1.927c2.475-2.567 2.475-6.75 0-9.32a6.192 6.192 0 00-8.979 0c-2.473 2.57-2.473 6.75 0 9.32a6.211 6.211 0 004.49 1.927zM7.085 66.898c.416-1.389 4.146-13.663 6.863-16.38 3.06-3.056 8.036-3.059 11.098 0 3.06 3.06 3.06 8.04 0 11.099-2.717 2.717-14.99 6.447-16.38 6.863a1.267 1.267 0 01-1.264-.32 1.273 1.273 0 01-.317-1.262z",
    fill: "url(#rocket-big_svg__paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "rocket-big_svg__paint0_linear",
    x1: 71.363,
    y1: 6.467,
    x2: 7.031,
    y2: 68.534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#368FFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33BB40"
  })))));
};

export default SvgRocketBig;